var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimealarm1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9482 85.8975L26.9226 75.6411",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0515 85.8975L73.0771 75.6411",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9997 85.8974C66.9931 85.8974 80.7689 72.1215 80.7689 55.1281C80.7689 38.1347 66.9931 24.3589 49.9997 24.3589C33.0063 24.3589 19.2305 38.1347 19.2305 55.1281C19.2305 72.1215 33.0063 85.8974 49.9997 85.8974Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2769 17.3885C40.2877 14.6369 36.4296 13.0186 32.3719 12.8143C28.3142 12.6099 24.3131 13.8325 21.0625 16.2698C17.812 18.7071 15.5173 22.2054 14.5764 26.1578C13.6355 30.1102 14.1079 34.2672 15.9116 37.9077",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.088 37.9076C85.2634 35.5438 85.8822 32.9423 85.897 30.3024C85.9097 26.9179 84.936 23.603 83.0949 20.7631C81.2538 17.9231 78.6251 15.6811 75.5302 14.3111C72.4353 12.9411 69.0083 12.5026 65.6682 13.0491C62.3281 13.5956 59.2196 15.1035 56.7227 17.3883",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6152 39.7437L49.9999 55.1283L61.5383 43.5898",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimealarm1);
export default __webpack_public_path__ + "static/media/Time alarm 1.9b568b73dfb645e115e3cc1e0f557a99.svg";
export { ForwardRef as ReactComponent };